import { useState, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { games, categories } from '@/mocks/games';

const categorySchema = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: '新葡京娱乐城 - 游戏中心',
  description: '新葡京娱乐城游戏中心，涵盖真人娱乐、老虎机、体育竞猜、彩票、棋牌等全品类游戏。',
  url: 'https://sportsinn.github.io/category',
};

export default function Category() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'all';

  const filteredGames = useMemo(() => {
    if (activeTab === 'all') return games;
    return games.filter((g) => g.category === activeTab);
  }, [activeTab]);

  const handleTabChange = (key: string) => {
    setSearchParams({ tab: key });
  };

  return (
    <>
      <SchemaOrg schema={categorySchema} />
      <Navbar />
      <main className="pt-16">
        <Breadcrumb items={[{ label: '游戏中心' }]} />

        <section className="w-full py-10 md:py-14 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              游戏中心
            </h1>
            <p className="text-sm text-foreground-500 mb-8">
              探索新葡京娱乐城全部游戏，找到您的专属乐趣
            </p>

            <div className="flex items-center gap-2 overflow-x-auto pb-2 mb-10 flex-wrap">
              {categories.map((cat) => (
                <button
                  key={cat.key}
                  onClick={() => handleTabChange(cat.key)}
                  className={`flex items-center gap-1.5 px-4 py-2 text-sm font-medium whitespace-nowrap rounded-full transition-all duration-200 cursor-pointer ${
                    activeTab === cat.key
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  <i className={`${cat.icon} text-base`}></i>
                  {cat.name}
                  {activeTab === cat.key && (
                    <span className="ml-1 text-xs opacity-80">
                      ({filteredGames.length})
                    </span>
                  )}
                </button>
              ))}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {filteredGames.map((game) => (
                <div
                  key={game.id}
                  className="group bg-background-100 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={game.image}
                      alt={game.name}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                      title={`${game.name} - 新葡京娱乐城 ${game.categoryName}`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                    <div className="absolute top-3 left-3 flex gap-2">
                      {game.tags.map((tag) => (
                        <span
                          key={tag}
                          className="px-2 py-0.5 text-xs rounded-md bg-accent-500 text-white whitespace-nowrap"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className="p-4">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-xs text-foreground-400 bg-background-200 px-2 py-0.5 rounded-md whitespace-nowrap">
                        {game.categoryName}
                      </span>
                    </div>
                    <h3 className="text-base font-medium text-foreground-900 mb-3">
                      {game.name}
                    </h3>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-1">
                        <i className="ri-star-fill text-amber-400 text-sm"></i>
                        <span className="text-sm text-foreground-600">{game.rating}</span>
                      </div>
                      <span className="text-xs text-foreground-500">
                        {game.players.toLocaleString()} 人在玩
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {filteredGames.length === 0 && (
              <div className="text-center py-20">
                <p className="text-foreground-500">暂无该分类的游戏</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}